<template>
  <table-view ref="table" v-if="hasAnyWebHooksModule" class="h-full"
    :get-params-path="getParamsPathAux"
    :get-params-detalle="getParamsDetalleAux"
    :get-detalle="isFromClient ? getDetalleAux : null"
    :get-pag="getPagAux"
    :get-excel="getExcelAux"
    :get-params="getParamsAux"
    :normalize-data="normalizeData"
    :filter-panel="FilterPanel"
    :route-name="routeName"
    excel-name="webhooks.xlsx"
    :id-vista="idVista"
    :header-title="headerTitle"
    :header-icon="headerIcon"
    :header-url="headerUrl"
    :detail-response-path="detailResponsePath"
    :vuexnamespace="vuexnamespace"
    :payload-single-id="PayloadSingleId"
    breadcrumb-name="Name"
    :breadcrumbs="breadcrumbs"
    :lista-acciones="listaAcciones"
    :footer-acciones="footerAcciones"
    @executeAction="executeAction" />
  <detail-layout-full-width v-else class="h-full">
    <template slot="header">
      <base-header icon="user" :content="header" />
    </template>
    <template slot="main">
      <div class="dark:text-white">{{ $t('feedback.error.absent_module_error') }}</div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
        </template>
      </base-footer>
    </template>
  </detail-layout-full-width>
</template>

<script>
import { i18n } from '@/i18n'
import DetailLayoutFullWidth from '@/components/layout/DetailLayoutFullWidth.vue'
import TableView from '@/components/interfaces/TableView.vue'
import CustomFilter from '@/components/filters/WebHooksFilter.vue'
import { getClient } from '@/services/clients/getClient'
import { getWebhooksPag } from '@/services/configurations/webhooks/getWebhooksPag'
import { getWebhooksExcel } from '@/services/configurations/webhooks/getWebhooksExcel'
import { enableWebhooks } from '@/services/configurations/webhooks/enableWebhooks'
import { disableWebhooks } from '@/services/configurations/webhooks/disableWebhooks'

export default {
  name: 'webhooks-list-view',
  components: {
    DetailLayoutFullWidth,
    TableView
  },
  data () {
    return {
      idVista: 90,
      FilterPanel: CustomFilter,
      vuexnamespace: 'webhooks',
      headerTitle: i18n.t('webhooks.header'),
      headerIcon: 'config',
      headerUrl: 'configurations/clients/details',
      routeName: 'configurations/clients/webhooks/detail',
      detailResponsePath: 'Cliente',
      breadcrumbs: [
        { 
          url: this.role === 3 ? 'configurationssa' : 'configurations', 
          name: i18n.t('configurations.header') 
        },
        { url: 'configurations/clients', name: i18n.t('clients.header') },
        { paths: ['Nombre'] },
      ],
      PayloadSingleId: ['IdCliente', 'IdWebHookSubscriber'],
      listaAcciones: [
        { IdAccion: 1, icon: 'check', Descripcion: i18n.t('app.enable') },
        { IdAccion: 2, icon: 'cross', Descripcion: i18n.t('app.disable') },
      ],
      footerAcciones: [{ text: i18n.t('webhooks.new_webhook'), icon: 'plus', handler: this.goToNewWebHook }]
    }
  },
  computed: {
    id: function () {
      return Number.parseInt(this.$route.params.id ? this.$route.params.id : this.$store.getters['auth/user'].idCliente)
    },
    isFromClient: function () {
      return !!this.$route.params.id
    },
    hasAnyWebHooksModule: function () {
      return this.$store.getters['auth/hasAnyWebHooksModule']
    },
    hasReceivedWebHooksModule: function () {
      return this.$store.getters['auth/hasReceivedWebHooksModule']
    },
    hasIssuedWebHooksModule: function () {
      return this.$store.getters['auth/hasIssuedWebHooksModule']
    },
    tiposWebhookNotification: function () {
      return this.$store.getters['config/TIPOS_WEBHOOK_NOTIFICATION']
    }
  },
  mounted () {
    this.headerUrl = this.isFromClient ? 'configurations/clients/details' : 'configurations'
    this.routeName = this.isFromClient ? 'configurations/clients/webhooks/detail' : 'configurations/webhooks/detail'
    if (!this.isFromClient) {
      this.breadcrumbs = []
    }
  },
  methods: {
    getParamsPathAux (data) {
      if (this.isFromClient) {
        return { id: this.id, idWebHook: data.IdWebHookSubscriber }
      }
      return { idWebHook: data.IdWebHookSubscriber }
    },
    getParamsDetalleAux () {
      return { idCliente: this.id }
    },
    getParamsAux (data) {
      return {
        idCliente: this.id,
        name: data.name ? data.name.value : null,
        url: data.url ? data.url.value : null,
        notificationType: data.notificationType ? data.notificationType.value : null,
        activo: data.activo ? data.activo.value : null,
      }
    },
    getDetalleAux: async function (objOrder, params) {
      return await getClient(objOrder, params)
    },
    getPagAux: async function (objOrder, params) {
      return await getWebhooksPag(objOrder, params)
    },
    getExcelAux: async function (objOrder, params) {
      return await getWebhooksExcel(objOrder, params)
    },
    normalizeData: function (data = []) {
      return data.map(item => {
        item.NotificationTypeKey = item.NotificationType
        item.NotificationType = this.tiposWebhookNotification.find(x => x.value === item.NotificationTypeKey)?.label ?? item.NotificationTypeKey
        return item
      })
    },
    goToNewWebHook: function () {
      const params = this.isFromClient ? { id: this.id, idWebHook: -1 } : { idWebHook: -1 }
      this.$router.push({ name: this.routeName, params })
    },
    executeAction: async function (action, selected = []) {
      if (selected.length) {
        const data = {
          IdClient: this.id,
          IdSubscribers: selected.map(x => x.IdWebHookSubscriber),
        }
        var response = null
        var successMsg = null
        if (action.IdAccion === 1) { // Activar
          response = await enableWebhooks(data)
          successMsg = i18n.tc('feedback.success.webhook_enabled_msg', selected.length)
        } else if (action.IdAccion === 2) { // Desactivar
          response = await disableWebhooks(data)
          successMsg = i18n.tc('feedback.success.webhook_disabled_msg', selected.length)
        } else {
          console.error(i18n.t('feedback.error.unexpected_action_error', { action: JSON.stringify(action) }))
          return
        }

        if (!response || (!response.blnError && !response.Respuesta)) {
          this.doFeedback()
        } else if (response.blnError) {
          this.doFeedback(`${response.msgError} [${response.codError}]`)
        } else {
          this.doFeedback(successMsg, 'success')
          this.$refs.table.applyFilters()
        }
      }
    }
  },
}
</script>

<style scoped>

</style>
